import { getLanguageKey, isExpired } from 'utils';
import {
  createFetchEntities,
  makeUpdateStatus,
} from '../appcontent/appcontent.utils';

export const filterOffers = offers =>
  offers.filter(
    offer =>
      offer.status !== 'USER_REDEEMED' &&
      offer.status !== 'SYSTEM_REDEEMED' &&
      !isExpired(offer.redemptionEndDate),
  );

export const makeDeleteOffer = (sliceName, action) =>
  makeUpdateStatus(
    `${sliceName}/deleteOffer`,
    '/changedistributedofferstatus',
    distributedOfferId => ({ distributedOfferId, redeemStatus: 'DELETED' }),
    distributedOfferId => action(distributedOfferId),
  );

export const makeUpdateOffer = (sliceName, action) =>
  makeUpdateStatus(
    `${sliceName}/updateStatus`,
    '/changedistributedofferstatus',
    (distributedOfferId, redeemStatus) => ({
      distributedOfferId,
      redeemStatus,
    }),
    (id, status) => action({ id, changes: { status } }),
  );

export const makeFetchOffers = (sliceName, getActions, selectors, loyalty) =>
  createFetchEntities(
    `${sliceName}/fetchOffers`,
    '/appoffers',
    response => getActions().upsertMany(response.data?.offerList?.offers ?? []),
    response =>
      getActions().totalPages(
        response.data?.offerList?.paging?.totalPages ?? 0,
      ),
    (page, thunkAPI) =>
      getActions().retrievedPages(
        Math.max(page, selectors.selectRetrievedPages(thunkAPI.getState())),
      ),
    response => response.data?.offerList?.offers,
    {
      count: 100,
      languageCode: getLanguageKey().toUpperCase(),
      page: 1,
      loyalty,
    },
    {
      condition: (_, { getState }) => !selectors.selectLoading(getState()),
    },
  );
